// TODO: Add types for responses and parameters
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../network/api';
import { Country } from 'types/common';
import { AxiosResponse } from 'axios';

export const getFarmersGroupList = createAsyncThunk(
  'pipe/getFarmersGroupList',
  async (_, thunkAPI) => {
    try {
      const response = await API.get(`/cubes/agronomist-cube`);
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getFarmersGroupDetails = createAsyncThunk(
  'pipe/getFarmersGroupDetails',
  async (cubeId, thunkAPI) => {
    try {
      const response = await API.get(`/cubes/${cubeId}`);
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getDistrictList = createAsyncThunk<Country, string>(
  'pipe/getDistrictList',
  async (country, thunkAPI) => {
    try {
      const response: AxiosResponse<Country> = await API.get(
        `/config/country/${country}  `,
      );
      return response.data;
    } catch (e: any) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
